// ProfileCategories.js
'use strict';
import { connect } from 'react-redux';

import ProfileCategories from '../component/ProfileCategories.jsx';

import getRemoteConfigData from '../selector/getRemoteConfigData.js';
import getIsCategoryEmpty from '../selector/getIsCategoryEmpty.js';
import getProfileFeedUnixTimestamp from '../selector/getProfileFeedUnixTimestamp.js';
import getMeData from '../selector/getMeData.js';

const mapStateToProps = (state, { userId, remoteConfigKey }) => {
  const categories = getRemoteConfigData(state, remoteConfigKey, undefined, {
    USER_ID: userId,
  });
  const meId = getMeData(state, 'id');
  return {
    isFetchedAndEmpty: getIsCategoryEmpty(state, categories),
    categoryTemplates: getRemoteConfigData(state, remoteConfigKey),
    profileFeedUnixTimestamp: getProfileFeedUnixTimestamp(state, meId),
    categories,
  };
};

export default connect(mapStateToProps, null)(ProfileCategories);
